export enum EScrollingBlocks {
  ValuationFilters = 'valuationFilters',
  MarketPrice = 'marketPrice',
  PreciseFilters = 'preciseFilters',
  AboutHome = 'aboutHome',
  OffersHistory = 'offersHistory',
  Recommendations = 'recommendations',
  EstimationChart = 'estimationChart',
  MarketTrends = 'marketTrends',
  PriceDynamic = 'priceDynamic',
  SupplyDemand = 'supplyDemand',
  DealTypeTabs = 'dealTypeTabs',
  Infrastructure = 'infrastructure',
  ObjectInfo = 'objectInfo',
  ManagementCompany = 'managementCompany',
}

export const mapScrollingBlocks: Record<string, EScrollingBlocks> = {
  valuationFilters: EScrollingBlocks.ValuationFilters,
  marketPrice: EScrollingBlocks.MarketPrice,
  preciseFilters: EScrollingBlocks.PreciseFilters,
  aboutHome: EScrollingBlocks.AboutHome,
  offersHistory: EScrollingBlocks.OffersHistory,
  recommendations: EScrollingBlocks.Recommendations,
  estimationChart: EScrollingBlocks.EstimationChart,
  marketTrends: EScrollingBlocks.MarketTrends,
  dealTypeTabs: EScrollingBlocks.DealTypeTabs,
  infrastructure: EScrollingBlocks.Infrastructure,
  objectInfo: EScrollingBlocks.ObjectInfo,
  managementCompany: EScrollingBlocks.ManagementCompany,
  // Костыль для мобильных приложений
  ManagementCompany: EScrollingBlocks.ManagementCompany,
};
